import {faDollar, faGolfBallTee, faFlask, faBullhorn, faHandHoldingHeart} from "@fortawesome/free-solid-svg-icons";
import {faCalendar} from "@fortawesome/free-regular-svg-icons";
import sponsorDragonLogo from './img/sponsor-dragon-logo.png';

export const donationLink = "//www.zeffy.com/donation-form/efebfe2b-d395-4073-ab22-304651b2039d"
export const registrationLink = '//www.zeffy.com/en-US/ticketing/player-registration-9th-annual';
export const sponsorshipRegistrationLink = '//www.zeffy.com/en-US/ticketing/sponsorships-9th-annual-veds-research-and-awareness-golf-tournament'

export const dinnerSponsors = [
    {
        name: 'Dinner Sponsor',
        logo: sponsorDragonLogo,
        link: null // Add sponsor website URL here if available
    }
    // Add more dinner sponsors here as needed
];

export const sponsorshipTiers = [
    {
        name: 'Golf Sponsor',
        price: 5000,
    },
    {
        name: 'Prize Sponsor',
        price: 2000,
    },
    {
        name: 'Dinner Sponsor',
        price: 2000,
    },
    {
        name: 'Team Sponsor',
        price: 600,
    },
    {
        name: 'Hole Sponsor',
        price: 250,
    },
    {
        name: 'Player Sponsor',
        price: 150,
    },
];

export const playerInformationBullets = [
    { icon: faGolfBallTee, text: 'Scramble Format' },
    { icon: faCalendar, text: 'Friday 9th October, 2026' },
    { icon: faDollar, text: '$150 per Player or $600 per Team *' },
]

export const missionCards = [
    {
        title: 'Research',
        description: 'We fund critical research to better understand and treat Vascular Ehlers-Danlos Syndrome.',
        icon: faFlask
    },
    {
        title: 'Awareness',
        description: 'We raise awareness about VEDS to help improve diagnosis and support for those affected.',
        icon: faBullhorn
    },
    {
        title: 'Support',
        description: 'We provide support for individuals and families affected by VEDS through community events and resources.',
        icon: faHandHoldingHeart
    }
];

export const vedsEmail = 'info@bellasmission.org';
export const emailSubject = (isDonations) => encodeURIComponent(`[${isDonations ? 'Donations' : 'Volunteering'}] - Bella's Mission`);
export const emailBody = (isDonations) => `Hello%20Frances%2C%20%0D%0A%0D%0AMy%20name%20is%20JohnDoe%20and%20I%20am%20interested%20in%20${isDonations ? 'donating%20to' : 'volunteering%20for'}%20Bella's%20Mission.%0D%0A%0D%0AMy%20contact%20info%20is%3A%0D%0AName%20-%20%0D%0APhone%20-%20%0D%0AEmail%20-%20%0D%0A%0D%0AThank%20you%2C%0D%0A`;